import { useEffect } from 'react';
import { animateScroll } from 'react-scroll';
import { TOTAL_PARAGRAPH_DURATION } from './Giveback2021Paragraph';
import { GIVEBACK_2021_TEXTS_WITH_SECTIONS } from './giveback2021Texts';

const RESTART_DURATION = 8000;
const SCROLL_DURATION = 5000;
const INITIAL_DELAY = 4000;
const DELAY_AFTER_SECTION = 50;
const END_DELAY = 7500;
const RESTART_DELAY = RESTART_DURATION + INITIAL_DELAY;
const LAST_SECTION_DELAY =
  GIVEBACK_2021_TEXTS_WITH_SECTIONS[GIVEBACK_2021_TEXTS_WITH_SECTIONS.length - 1].items.length *
    TOTAL_PARAGRAPH_DURATION +
  DELAY_AFTER_SECTION +
  SCROLL_DURATION;

function getTotalDuration(): number {
  return (
    GIVEBACK_2021_TEXTS_WITH_SECTIONS.reduce((sum, _, index) => {
      const previousSection = GIVEBACK_2021_TEXTS_WITH_SECTIONS[index - 1];
      const previousSectionDelay = previousSection ? previousSection.items.length * TOTAL_PARAGRAPH_DURATION : 0;
      return sum + previousSectionDelay + DELAY_AFTER_SECTION + SCROLL_DURATION;
    }, INITIAL_DELAY) +
    LAST_SECTION_DELAY +
    END_DELAY +
    RESTART_DELAY
  );
}

function scheduleScroll(): void {
  let accumulatedDelay = INITIAL_DELAY;

  GIVEBACK_2021_TEXTS_WITH_SECTIONS.forEach((section, index) => {
    const previousSection = GIVEBACK_2021_TEXTS_WITH_SECTIONS[index - 1];
    const previousSectionDelay = previousSection ? previousSection.items.length * TOTAL_PARAGRAPH_DURATION : 0;
    accumulatedDelay += previousSectionDelay + DELAY_AFTER_SECTION + SCROLL_DURATION;
    setTimeout(() => {
      animateScroll.scrollTo(section.position, {
        smooth: true,
        duration: SCROLL_DURATION,
      });
    }, accumulatedDelay);
  });

  setTimeout(() => {
    animateScroll.scrollTo(document.documentElement.scrollHeight, {
      smooth: true,
      duration: SCROLL_DURATION,
    });
  }, accumulatedDelay + LAST_SECTION_DELAY);

  setTimeout(
    () => {
      animateScroll.scrollTo(0, {
        smooth: true,
        duration: RESTART_DURATION,
      });
    },
    accumulatedDelay + LAST_SECTION_DELAY + END_DELAY,
  );
}

export function useGiveback2021Presentation(enabled: boolean): void {
  useEffect(() => {
    scheduleScroll();
    const interval = window.setInterval(scheduleScroll, getTotalDuration());

    return () => window.clearInterval(interval);
  }, []);
  if (!enabled) return;
}
